// extracted by mini-css-extract-plugin
export default {"container":"D3yaa","content":"Z22dE"};